module.exports = require("cookie-parser");


//////////////////
// WEBPACK FOOTER
// external "cookie-parser"
// module id = 21
// module chunks = 0